import React, { useEffect, useState, useContext } from "react";
import Container from "react-bootstrap/Container";
import { Link, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";
import Logo from "../images/noImage.png";
import UserImg from "../images/userimg.png";
import { Badge } from "react-bootstrap";
import { AppDataContext } from "../services/appData";
import PlusIcon from "../images/plusicon.svg";
import Button from "react-bootstrap/Button";
import * as PIC from "../../services/env";
import * as API from "../../services/env";

const Header = () => {
  const { setIsLogin, setTheme, togalState } = useContext(AppDataContext);
  const location = useLocation(); // once ready it returns the 'window.location' object
  const [url, setUrl] = useState(null);
  const [datas, setdatas] = useState("");
const viewCounts  = JSON.parse(localStorage.getItem("viewCount"));
const notifcationCounts  = JSON.parse(localStorage.getItem("notifcationCount"));



  const [viewCount,setviewCount] = useState('')
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("userDetail"));
    if (data) {
      // setdatas("https://accel.indiitserver.in:3001/server/" + data.pic);
      setUrl(location.pathname);
    }
  }, [location]);

  const fetchUserData = async (arr) => {

    let payload = {
      username: arr,
    };
    const data = JSON.parse(localStorage.getItem("email"));

    fetch(`${API.BASE_URL}fetchUserDomain`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      // mode: "cors",
      body: JSON.stringify({
        username: data,
      }), // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status == true) {
          // localStorage.setItem("userDetail", JSON.stringify(res.data[0]));
          setdatas(   `${PIC.PIC_URL}` + res.data[0].pic);
          // setdomain(res.data[0].userName);
          // window.location.href = "/accel/login";
        } else {
        }
      })
      .catch((error) => {});
 
  };

  const fetchViewCount = async (arr) => {
    const userData = localStorage.getItem("userDetail");
    if (userData) {
      var data = JSON.parse(userData);
    }

    // let payload = {
    //   userId: data._id,
    // };
    if(data){
      fetch(`${API.BASE_URL}viewSatutsscreening`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        // mode: "cors",
        body: JSON.stringify({
          userId: data._id,
        }), // body data type must match "Content-Type" header
      })
        .then((response) => response.json())
        .then(async (res) => {
          if (res.status == true) {
            localStorage.setItem("viewCount", JSON.stringify('0'));
  
            setviewCount(res.ViewCount)
          } else {
          }
        })
        .catch((error) => {});
   
    }
    
  };


  useEffect(() => {
    const host = window.location.hostname;
    const arr = host.split(".")[0];

    if(viewCounts==null){
      fetchViewCount()
    }
    fetchUserData();
    if(viewCounts=='0'){
      fetchViewCount()

    }
  }, [viewCounts]);

 

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      id="home"
      className="bg-primary afterLogin"
    >
      <Container fluid className="widthSmall">
        <Navbar.Brand as={Link} to="/dashboard">
          <Image src={datas && datas} alt="" className="logoicon" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />

        <Navbar.Collapse id="navbarScroll">
          <Nav className="ms-auto padTab padTabLink">
            <Button
              as={Link}
              variant="warning"
              size="md"
              className="btnPadNew"
              to="/add-screening"
            >
              <Image src={PlusIcon} alt="" className="me-2" /> Add New Screening
            </Button>

            <Nav.Link
              className={url === "/dashboard" ? " active" : ""}
              as={Link}
              to="/dashboard"
            >
              <svg width="22" height="19" viewBox="0 0 22 19" fill="none">
                <path
                  d="M13.5234 18.1671C13.4508 18.1671 13.3761 18.1639 13.3013 18.1563C12.348 18.0621 11.6005 17.3893 11.3947 16.4414L8.48808 3.01673L5.49483 9.93056C5.32258 10.3271 4.93149 10.5838 4.50033 10.5838H1.25033C0.651242 10.5838 0.166992 10.0985 0.166992 9.50048C0.166992 8.9014 0.651242 8.41715 1.25033 8.41715H3.78966L6.50449 2.14573C6.88907 1.26173 7.73624 0.747147 8.69932 0.843564C9.65266 0.937814 10.4002 1.61056 10.606 2.55848L13.5126 15.9831L16.5058 9.06931C16.6781 8.67281 17.0681 8.41715 17.5003 8.41715H20.7503C21.3494 8.41715 21.8337 8.9014 21.8337 9.50048C21.8337 10.0985 21.3494 10.5838 20.7503 10.5838H18.211L15.4962 16.8541C15.1419 17.6699 14.3825 18.1671 13.5234 18.1671Z"
                  fill="#8E8E8E"
                />
              </svg>
              Dashboard
            </Nav.Link>

            <Nav.Link
              className={url === "/screenings" ? " active" : ""}
              as={Link}
              to="/screenings"
            >
              <svg width="22" height="23" viewBox="0 0 22 23" fill="none">
                <path
                  d="M20.5564 13.7294C19.9898 13.5279 19.3723 13.8236 19.1741 14.3891C17.9521 17.845 14.6663 20.1666 11.0003 20.1666C6.22174 20.1666 2.33366 16.2796 2.33366 11.4999C2.33366 7.83389 4.65524 4.54814 8.11107 3.32614C8.67549 3.12789 8.97124 2.50931 8.77191 1.94489C8.57257 1.38156 7.95399 1.08473 7.38958 1.28514C3.06924 2.81156 0.166992 6.91631 0.166992 11.4999C0.166992 17.4734 5.02683 22.3332 11.0003 22.3332C15.5839 22.3332 19.6887 19.4321 21.2162 15.1106C21.4155 14.5473 21.1208 13.9287 20.5564 13.7294ZM13.167 9.33422V2.91113C16.4831 3.3878 19.1134 6.01705 19.5901 9.33422H13.167ZM12.0833 0.666992C11.4853 0.666992 11 1.15124 11 1.75033V10.417C11 11.0161 11.4853 11.5003 12.0833 11.5003H20.75C21.348 11.5003 21.8333 11.0161 21.8333 10.417C21.8333 5.04041 17.4588 0.666992 12.0833 0.666992Z"
                  fill="#8E8E8E"
                />
              </svg>
              Requests
              <Badge pill bg="primary">
               {/* {viewCounts =='1'?'0':viewCount} */}
              </Badge>
            </Nav.Link>

            <Nav.Link
              className={url === "/subscription" ? " active" : ""}
              as={Link}
              to="/subscription"
            >
              <svg width="24" height="17" viewBox="0 0 24 17" fill="none">
                <path
                  d="M16.0625 11.75C15.847 11.75 15.6403 11.8356 15.488 11.988C15.3356 12.1403 15.25 12.347 15.25 12.5625C15.25 12.778 15.3356 12.9847 15.488 13.137C15.6403 13.2894 15.847 13.375 16.0625 13.375H19.3125C19.528 13.375 19.7347 13.2894 19.887 13.137C20.0394 12.9847 20.125 12.778 20.125 12.5625C20.125 12.347 20.0394 12.1403 19.887 11.988C19.7347 11.8356 19.528 11.75 19.3125 11.75H16.0625ZM0.625 4.4375C0.625 3.36006 1.05301 2.32675 1.81488 1.56488C2.57675 0.803012 3.61006 0.375 4.6875 0.375H19.3125C20.3899 0.375 21.4233 0.803012 22.1851 1.56488C22.947 2.32675 23.375 3.36006 23.375 4.4375V12.5625C23.375 13.6399 22.947 14.6733 22.1851 15.4351C21.4233 16.197 20.3899 16.625 19.3125 16.625H4.6875C3.61006 16.625 2.57675 16.197 1.81488 15.4351C1.05301 14.6733 0.625 13.6399 0.625 12.5625V4.4375ZM21.75 5.25V4.4375C21.75 3.79103 21.4932 3.17105 21.0361 2.71393C20.579 2.25681 19.959 2 19.3125 2H4.6875C4.04103 2 3.42105 2.25681 2.96393 2.71393C2.50681 3.17105 2.25 3.79103 2.25 4.4375V5.25H21.75ZM2.25 6.875V12.5625C2.25 13.209 2.50681 13.829 2.96393 14.2861C3.42105 14.7432 4.04103 15 4.6875 15H19.3125C19.959 15 20.579 14.7432 21.0361 14.2861C21.4932 13.829 21.75 13.209 21.75 12.5625V6.875H2.25Z"
                  fill="#8E8E8E"
                />
              </svg>
              Subscription
            </Nav.Link>

            <Nav.Link
              className={url === "/notifications" ? " active" : ""}
              as={Link}
              to="/notifications"
            >
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
                <path
                  d="M2.41667 18.0003H17.5833V10.4506C17.5833 6.24399 14.1882 2.83366 10 2.83366C5.81183 2.83366 2.41667 6.24399 2.41667 10.4506V18.0003ZM10 0.666992C15.3842 0.666992 19.75 5.04691 19.75 10.4506V20.167H0.25V10.4506C0.25 5.04691 4.61583 0.666992 10 0.666992ZM7.29167 21.2503H12.7083C12.7083 21.9686 12.423 22.6575 11.9151 23.1654C11.4072 23.6733 10.7183 23.9587 10 23.9587C9.28171 23.9587 8.59283 23.6733 8.08492 23.1654C7.57701 22.6575 7.29167 21.9686 7.29167 21.2503Z"
                  fill="#8E8E8E"
                />
              </svg>
              <Badge pill bg="primary">
               {notifcationCounts&&notifcationCounts}
              </Badge>
              Notifications
            </Nav.Link>

            <Nav.Link
              className={url === "/settings" ? " active" : ""}
              as={Link}
              to="/settings"
            >
              <svg width="22" height="23" viewBox="0 0 22 23" fill="none">
                <path
                  d="M2.76975 11.0902C3.97875 11.5051 4.94183 12.5169 5.34483 13.7996L5.38816 13.9296C5.84966 15.2903 5.66225 16.7549 4.88875 17.8534C4.74791 18.0528 4.77933 18.2911 4.92775 18.4038L7.17241 20.1089C7.2515 20.1685 7.32841 20.1685 7.37608 20.1631C7.43025 20.1544 7.50933 20.1252 7.57325 20.0342L7.8235 19.6788C8.56991 18.6204 9.77241 17.9672 11.0421 17.9303C12.4677 17.9011 13.7482 18.5543 14.5456 19.7059L14.6734 19.8912C14.7373 19.9822 14.8153 20.0125 14.8706 20.0212C14.9182 20.0309 14.9962 20.0277 15.0742 19.967L17.307 18.2824C17.463 18.1654 17.4977 17.9152 17.3817 17.7473L17.1001 17.341C16.3742 16.2923 16.1587 14.9317 16.5237 13.7021C16.9202 12.3631 17.9288 11.3036 19.2234 10.8703L19.4412 10.7966C19.6156 10.7392 19.7098 10.5225 19.6481 10.3232L18.7955 7.59209C18.7554 7.46426 18.6731 7.40684 18.6276 7.38301C18.5626 7.34942 18.4922 7.34401 18.425 7.36676L18.0567 7.48917C16.7967 7.90842 15.4068 7.68092 14.3397 6.87817L14.2227 6.79042C13.2087 6.02776 12.6053 4.79817 12.6097 3.50251L12.6118 3.19917C12.6118 3.05509 12.5436 2.96517 12.5024 2.92401C12.4634 2.88392 12.3973 2.83626 12.3042 2.83626L9.54491 2.83301C9.37591 2.83301 9.23833 2.99442 9.23725 3.19376L9.23616 3.45592C9.23075 4.77217 8.61433 6.02451 7.58733 6.80776L7.44758 6.91392C6.31766 7.77301 4.84433 8.01567 3.50966 7.56067C3.45875 7.54334 3.41108 7.54659 3.36558 7.57043C3.33091 7.58776 3.26808 7.63217 3.23775 7.73076L2.35266 10.5431C2.28875 10.7478 2.39383 10.9613 2.59208 11.0295L2.76975 11.0902ZM7.33191 22.3337C6.80541 22.3337 6.29408 22.1625 5.86291 21.8342L3.61825 20.1302C2.54575 19.3177 2.3085 17.7544 3.0885 16.6462C3.49366 16.072 3.57708 15.3342 3.33875 14.6344L3.27916 14.4524C3.08091 13.8219 2.62808 13.3322 2.068 13.1405H2.06691L1.89033 13.0787C0.570831 12.627 -0.133336 11.2284 0.285914 9.89374L1.16991 7.08249C1.37033 6.44658 1.80258 5.93307 2.38758 5.63732C2.95958 5.34916 3.60633 5.30474 4.21083 5.51166C4.85975 5.73266 5.58016 5.61241 6.13591 5.18991L6.27566 5.08374C6.76966 4.70674 7.06758 4.09466 7.06975 3.44791L7.07083 3.18683C7.07625 1.79583 8.18666 0.666992 9.54408 0.666992H9.54842L12.3077 0.670242C12.9598 0.671326 13.5752 0.929159 14.0388 1.39608C14.5187 1.87816 14.7809 2.52274 14.7787 3.21066L14.7766 3.51291C14.7744 4.12608 15.055 4.70566 15.5284 5.06099L15.6443 5.14874C16.1416 5.52249 16.7894 5.62974 17.3712 5.43474L17.7384 5.31233C18.3635 5.10433 19.0287 5.15524 19.6147 5.45533C20.216 5.76299 20.6602 6.29274 20.8638 6.94816L21.7164 9.67924C22.1281 10.9987 21.4152 12.4222 20.1293 12.8523L19.9116 12.9249C19.2876 13.1351 18.7968 13.6551 18.6007 14.3181C18.4209 14.9258 18.5249 15.5942 18.8813 16.1077L19.163 16.514C19.9365 17.632 19.6895 19.2007 18.6127 20.0121L16.3799 21.6977C15.8437 22.1029 15.1861 22.2665 14.5263 22.1614C13.8612 22.0542 13.2805 21.6858 12.8916 21.1247L12.7637 20.9383C12.3846 20.3923 11.7779 20.0608 11.142 20.0966C10.505 20.1139 9.95466 20.4162 9.595 20.9275L9.34475 21.2828C8.95258 21.8386 8.37083 22.2015 7.70891 22.3055C7.58216 22.325 7.4565 22.3337 7.33191 22.3337ZM11 9.875C10.1041 9.875 9.375 10.6041 9.375 11.5C9.375 12.3959 10.1041 13.125 11 13.125C11.8959 13.125 12.625 12.3959 12.625 11.5C12.625 10.6041 11.8959 9.875 11 9.875ZM11.0007 15.2913C8.90982 15.2913 7.20898 13.5905 7.20898 11.4997C7.20898 9.40884 8.90982 7.70801 11.0007 7.70801C13.0915 7.70801 14.7923 9.40884 14.7923 11.4997C14.7923 13.5905 13.0915 15.2913 11.0007 15.2913Z"
                  fill="#8E8E8E"
                />
              </svg>
              Settings
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/support"
              className={url === "/support" ? " active" : ""}
            >
              <svg width="21" height="26" viewBox="0 0 21 26" fill="none">
                <path
                  d="M9.91699 25.0555V21.1555C4.48949 20.8738 0.166992 16.3672 0.166992 10.8747C0.166992 5.19801 4.78199 0.583008 10.4587 0.583008C16.1353 0.583008 20.7503 5.19801 20.7503 10.8747C20.7503 16.2372 17.0237 21.6322 11.4662 24.308L9.91699 25.0555ZM10.4587 2.74967C5.97366 2.74967 2.33366 6.38967 2.33366 10.8747C2.33366 15.3597 5.97366 18.9997 10.4587 18.9997H12.0837V21.4913C16.027 18.9997 18.5837 14.9047 18.5837 10.8747C18.5837 6.38967 14.9437 2.74967 10.4587 2.74967ZM9.37533 15.208H11.542V17.3747H9.37533V15.208ZM11.542 13.583H9.37533C9.37533 10.0622 12.6253 10.333 12.6253 8.16634C12.6253 6.97467 11.6503 5.99967 10.4587 5.99967C9.26699 5.99967 8.29199 6.97467 8.29199 8.16634H6.12533C6.12533 5.77217 8.06449 3.83301 10.4587 3.83301C12.8528 3.83301 14.792 5.77217 14.792 8.16634C14.792 10.8747 11.542 11.1455 11.542 13.583Z"
                  fill="#8E8E8E"
                />
              </svg>
              Support
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/"
              onClick={async () => {
                setIsLogin(false);
                setTheme(togalState);
                await localStorage.removeItem("userDetail");
                await localStorage.removeItem("userResponse");
                await localStorage.removeItem("screeningType");
                await localStorage.removeItem("hsCodeVerficationData");
                await localStorage.removeItem("token");
                await localStorage.removeItem("userResponse");
                await localStorage.removeItem("reference");

             

                



                await localStorage.clear();
                window.location.reload()
              }}
            >
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path
                  d="M20.0387 17.086H18.2537C18.1318 17.086 18.0176 17.1393 17.9414 17.2332C17.7637 17.4491 17.5732 17.6573 17.3726 17.8553C16.5522 18.6765 15.5805 19.331 14.5111 19.7825C13.4032 20.2504 12.2124 20.4905 11.0097 20.4883C9.79354 20.4883 8.61541 20.2496 7.50838 19.7825C6.439 19.331 5.46724 18.6765 4.64685 17.8553C3.825 17.0369 3.16967 16.0668 2.71717 14.9989C2.24744 13.8918 2.01131 12.7162 2.01131 11.5C2.01131 10.2838 2.24998 9.10824 2.71717 8.00121C3.16912 6.93227 3.81912 5.96996 4.64685 5.14477C5.47459 4.31957 6.43689 3.66957 7.50838 3.21762C8.61541 2.75043 9.79354 2.51176 11.0097 2.51176C12.226 2.51176 13.4041 2.74789 14.5111 3.21762C15.5826 3.66957 16.5449 4.31957 17.3726 5.14477C17.5732 5.34535 17.7611 5.55355 17.9414 5.76684C18.0176 5.86078 18.1344 5.9141 18.2537 5.9141H20.0387C20.1986 5.9141 20.2976 5.73637 20.2088 5.6018C18.2613 2.57523 14.8539 0.571913 10.9818 0.58207C4.89822 0.597304 0.020682 5.53578 0.0816195 11.6118C0.142557 17.5912 5.01248 22.418 11.0097 22.418C14.8717 22.418 18.2638 20.4172 20.2088 17.3983C20.2951 17.2637 20.1986 17.086 20.0387 17.086ZM22.2959 11.3401L18.6929 8.49633C18.5584 8.38969 18.3629 8.48617 18.3629 8.65629V10.586H10.3902C10.2785 10.586 10.1871 10.6774 10.1871 10.7891V12.211C10.1871 12.3227 10.2785 12.4141 10.3902 12.4141H18.3629V14.3438C18.3629 14.5139 18.5609 14.6104 18.6929 14.5037L22.2959 11.66C22.3202 11.641 22.3398 11.6167 22.3533 11.589C22.3668 11.5613 22.3738 11.5309 22.3738 11.5C22.3738 11.4692 22.3668 11.4388 22.3533 11.4111C22.3398 11.3834 22.3202 11.3591 22.2959 11.3401Z"
                  fill="#8E8E8E"
                />
              </svg>
              Log Out
            </Nav.Link>
          </Nav>
          {/* <Image src={UserImg} className="img-fluid useimg" /> */}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
